import React from 'react';
import styles from './UIButton-styles.module.scss';
import classnames from 'classnames';
import PropTypes from 'prop-types';

const types = ['primary', 'disabled', 'secondary', 'danger', 'submit', 'dark'];

const UIButton = ({
  type = 'primary',
  handleSubmit,
  text = '',
  disabled = false,
  shadow = true,
  buttonSmall = false,
  buttonSmaller = false,
  ...props
}) => {
  const disabledStyles = {
    opacity: 0.5,
    cursor: 'not-allowed',
  };

  return (
    <button
      style={disabled ? disabledStyles : {}}
      onClick={!disabled ? handleSubmit : null}
      className={classnames(
        buttonSmaller && styles['button-smaller'],
        buttonSmall && styles['button-small'],
        !buttonSmall && styles['button'],
        styles[`${type}`],
        shadow && styles[`shadow`],
      )}
      disabled={disabled}
      {...props}
    >
      {text}
    </button>
  );
};

UIButton.propTypes = {
  type: PropTypes.oneOf(types),
  handleSubmit: PropTypes.func,
  text: PropTypes.string,
  disabled: PropTypes.bool,
  shadow: PropTypes.bool,
  buttonSmall: PropTypes.bool,
  buttonSmaller: PropTypes.bool,
};

export default UIButton;
